import * as React from "react";
import { useTheme } from "styled-components";

import { style, Icon } from "./Symbolicons";

export const Tag = (props: Icon): React.ReactElement => {
  const theme = useTheme();

  return (
    <svg
      style={{ ...style(props.size, props.height), ...props.style }}
      className={props.className}
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill={props.color || theme.palette.grey600}
        fillRule="evenodd"
        clipRule="evenodd"
        d={
          props.variant === "line"
            ? "M18 4C19.0545 4 19.9188 4.81693 19.9934 5.85088L19.9987 6V10.6713C19.9987 11.1393 19.8348 11.5909 19.5392 11.9474L19.4222 12.0765L12.1938 19.4137C11.8649 19.7422 11.45 19.9323 11.0216 19.9841L10.8605 19.997L10.6989 19.9969C10.275 19.9798 9.85555 19.8285 9.50953 19.5432L9.36593 19.4127L4.58563 14.6324C3.84654 13.8924 3.80791 12.7173 4.4728 11.9288L4.59013 11.8011L11.9225 4.5774C12.2549 4.2485 12.6915 4.04809 13.1541 4.00762L13.3287 4H18ZM18 5.33333H13.3287C13.1881 5.33333 13.052 5.3776 12.9392 5.45866L12.8592 5.52624L5.5294 12.7474C5.29512 12.9817 5.27161 13.347 5.45861 13.6074L5.52874 13.6899L10.3087 18.4699C10.4389 18.6001 10.6095 18.6652 10.7796 18.6657L10.8814 18.6583C10.9823 18.6431 11.0802 18.6048 11.1661 18.5433L11.2478 18.4741L18.4734 11.1398C18.5716 11.0405 18.6355 10.9127 18.6572 10.7756L18.6653 10.6713V5.99879C18.6659 5.66519 18.4195 5.38817 18.0984 5.34056L18 5.33333ZM16.6622 7.92225C16.6237 7.59069 16.3419 7.33333 16 7.33333C15.6318 7.33333 15.3333 7.63181 15.3333 8L15.3378 8.08441C15.3763 8.41597 15.6581 8.67333 16 8.67333L16.0985 8.6661C16.42 8.61849 16.6667 8.34138 16.6667 8.00667L16.6622 7.92225Z"
            : "M13.4493 4H18.5453C19.3487 4 20 4.65133 20 5.45467V10.5507C20 10.9333 19.8493 11.3007 19.5807 11.5733L11.6993 19.5747C11.1307 20.1427 10.2093 20.1427 9.64133 19.5747L4.426 14.3593C3.858 13.7907 3.858 12.87 4.426 12.3013L12.4267 4.41933C12.6993 4.15067 13.0667 4 13.4493 4ZM14.6667 8C14.6667 8.736 15.264 9.33333 16 9.33333C16.7367 9.33333 17.3333 8.736 17.3333 8C17.3333 7.264 16.736 6.66667 16 6.66667C15.264 6.66667 14.6667 7.264 14.6667 8Z"
        }
      />
    </svg>
  );
};
